import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Print = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 1.5c-.3 0-.5.2-.5.5v3H2c-.3 0-.5.2-.5.5v5a.5.5 0 0 0 .5.5h2v3c0 .3.2.5.5.5h7c.3 0 .5-.2.5-.5v-3h2c.3 0 .5-.2.5-.5v-5A.5.5 0 0 0 14 5h-2V2c0-.3-.2-.5-.5-.5h-7ZM11 5V2.5H5V5h6ZM4.5 6h-2v4H4V8c0-.3.2-.5.5-.5h7c.3 0 .5.2.5.5v2h1.5V6h-9ZM11 8.5v5H5v-5h6ZM5.5 10c0-.3.2-.5.5-.5h4a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5Zm.5 1.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1H6Z"
      />
    </svg>
  )
})

export default Print
